import { Input, InputPassword } from "components";
import React, { useState } from 'react';
import { Typography, Snackbar, Grid, Paper, Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Login';
import { EurofinsLogo } from 'components/svg/EurofinsLogo';
import { ElvisConnect } from 'components/svg/ElvisConnect';
import { NavLink } from '../home/Home-components';
import { internalLogin } from 'services';
import { useNavigate } from "react-router";
import MuiAlert, { AlertProps } from '@mui/material/Alert';

export function InternalUserLogin() {
    let navigate = useNavigate();
    const [userName, setUserName] = useState();
    const [password, setPassword] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [open, setOpen] = useState(false);

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const loginUser = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        const params = {
            userName: userName,
            password: password
        }
        await internalLogin(params).then((res: any) => {
            if (res.status === 200) {
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('refreshToken', res.data.refreshToken);
                const jwt: any = res.data.token;
                let labUserCheck: any = jwt ? JSON.parse(atob(jwt.split('.')[1])) : null;
                if (labUserCheck) {
                    const isInternalUser = labUserCheck.UserType === 'Internal';

                    const hasPermission =
                        labUserCheck.Permission && labUserCheck.Permission.length > 0;

                    if (!hasPermission) {
                        navigate('/error');
                        return;
                    }

                    const hasAddUserPermission =
                        labUserCheck.Permission.includes('AddUser') ||
                        labUserCheck.Permission.includes('ManageClientUsers');

                    const hasOfficeAdminPermission =
                        labUserCheck.Permission.includes('ReviewOnboardRequest') ||
                        labUserCheck.Permission.includes('ActionOnboardRequest');

                    const hasDispatcherPermission =
                        labUserCheck.Permission.includes('ViewContainerOrder') ||
                        labUserCheck.Permission.includes('EditContainerOrder');

                    if (isInternalUser && hasAddUserPermission) {
                        navigate('/home/admin');
                    } else if (isInternalUser && !hasAddUserPermission && hasOfficeAdminPermission) {
                        navigate('/home/new-client-request');
                    } else if (isInternalUser && hasDispatcherPermission) {
                        navigate('/home/orderHistory');
                    } else {
                        navigate('/home/viewQuote');
                    }
                }
            } else {
                setError(res.status);
                setOpen(true);
                setTimeout(() => { setOpen(false) }, 6000);
            }
        }).finally(() => setLoading(false))
    }

    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    return (
        <Grid container component="main"
            sx={{
                height: "100vh",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
            <Grid
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "24px",
                    borderRadius: "6px"
                }}
                item
                xs={12}
                sm={8}
                md={3}
                component={Paper}
                elevation={0}
                square
            >
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                }}>
                    <div style={{
                        margin: "8px",
                        padding: "8px",
                        textAlign: "center"
                    }}>
                        <div><EurofinsLogo /></div>
                        <div><ElvisConnect /></div>
                        <Typography variant="h6" data-testid="title" mt="10px">Internal User Login</Typography>
                    </div>
                    <form style={{ width: "100%" }} data-testid="form" onSubmit={loginUser}>
                        <Input
                            required
                            fullWidth={true}
                            inputProps={{
                                "data-testid": 'username-field',
                            }}
                            onChange={(ev) => setUserName(ev.target.value)}
                            label="Email"
                        />
                        <InputPassword
                            required
                            inputProps={{
                                "data-testid": 'password-field',
                            }}
                            onChange={(ev: any) => setPassword(ev.target.value)}
                            label="Password"
                        />
                        <Button type="submit" variant="contained" sx={{ mt: 2, width: '100%' }} endIcon={<SendIcon />}>
                            Sign in
                        </Button>
                        <div style={{ width: '100%', textAlign: 'center', fontSize: '12px', marginTop: '24px' }}>
                            <NavLink to="/forgotpassword">Forgot Password?</NavLink>
                        </div>
                        <div style={{ width: '100%', textAlign: 'center', marginTop: '24px' }}>
                            <Typography variant="subtitle1" sx={{ fontSize: '14px' }}>
                                If you are Eurofins user please click <NavLink to="/famslogin">here</NavLink>.
                            </Typography>
                        </div>
                    </form>
                    <Typography variant="subtitle1" mt={2}>Copyright © Eurofins {new Date().getFullYear()}</Typography>
                </div>
            </Grid>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                {error === 404 ?
                    <Alert onClose={handleClose} severity="error">
                        Information incorrect for: Username/Password
                    </Alert>
                    : error === 500 ?
                        <Alert onClose={handleClose} severity="warning">
                            invalid username or password
                        </Alert>
                        :
                        <Alert onClose={handleClose} severity="warning">
                            The user account is inactive, contact your Eurofins Client Manager for details
                        </Alert>
                }
            </Snackbar>
        </Grid>
    )
}
